/** @jsx jsx */
import { css } from "@emotion/react";

export const header = css`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 5;
  background: transparent;
  padding: 40px;
  /* padding: 39px 40px 0 45px; */
  /* border-bottom: 2px solid rgba(255, 255, 255, 0.1); */

  &.fixedHeader {
    background-color: #ffffff;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    width: 100%;
    z-index: 999;
    border: none;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
    -webkit-box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
    -moz-box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  }

  &.black_color {
    border-color: #e5e5e5;

    &.fixedHeader {
      background-color: #4BE66A;
    }

    nav ul li a {
      color: #000000;
      &:after {
        background-color: #000000;
      }
    }

    nav ul ul {
      background-color: #ffffff;
      &:before {
        border-bottom: 5px solid #fff;
      }
    }
  }

  .socialsContainers{
    display: flex;
    align-items: center;
    align-content: center;
    @media (max-width: 500px){
    }
  }
  .socialitens{
    margin-left: 150px;
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    @media (max-width: 500px){
      margin-left: 0px;
    }
  }
   
  @media (min-width: 320px) and (max-width: 767px) {
    padding: 0px 0 0;
  }

  .headerDesktop{
    @media (max-width: 992px){
      display: none;
    }
  }
  
`;

export const logo = css`
  text-align: center;
  img {
    max-width: 100%;
    height: auto;
  @media (max-width: 767px) {
    padding: 0px 0 0;
  }
  }
`;

export const mainMenu = css`
  position: relative;
  font-family: 'Montserrat', sans-serif;
  margin-top: 10px;
  ul {
    margin: 0;
    padding: 0;

    & li {
      list-style: none;
      display: inline-block;
      padding-right: 16px;
      position: relative;

      & > .active a {
        color: #fff;
        &:after {
          width: 100%;
        }
      }

      & a {
        display: block;
        font-weight: 700;
        font-size: 16px;
        line-height: 150%;
        color: #312E2D;
        position: relative;

        &:hover {
          color: #00854E;
          text-decoration: none;
          &:after {
            width: 100%;
            background-color: #00854E;
            height: 3px;
          }
        }

        &:after {
          position: absolute;
          width: 0;
          height: 1px;
          content: "";
          background: #fff;
          left: 0;
          right: 0;
          bottom: -5px;
          -moz-transition: all 0.4s ease-out;
          -webkit-transition: all 0.4s ease-out;
          transition: all 0.4s ease-out;
        }
      }

      &:hover .sub-menu {
        visibility: visible;
        opacity: 1;
        top: 66px;
      }
    }

    & ul.sub-menu {
      padding: 25px 30px 13px;
      & li {
        margin: 0;
        /* padding: 0 0 13px; */
        display: block;
        & a {
          font-size: 14px;
          line-height: 1.5;
          display: inline-block;
          &:after {
            bottom: 0;
          }
        }
      }
    }
  }
`;

export const submenu = css`
  /* background-color: ${(props) => (props.dark ? "#ffffff" : "#000000")}; */
  background-color: #000000;
  width: 200px;
  z-index: 9;
  text-align: center;

  transition: all ease 400ms;
  -webkit-transition: all ease 400ms;
  -moz-transition: all ease 400ms;
  visibility: hidden;
  opacity: 0;
  left: 50%;
  margin: auto;
  position: absolute;
  right: 0;
  text-align: center;
  top: 100px;
  transform: translateX(-50%);
  z-index: 2;

  &:before {
    content: "";
    left: 0;
    margin: auto;
    position: absolute;
    right: 0;
    top: -5px;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid #000;
    z-index: 10;
  }
`;



export const btnAgendeSuaVisita = css`
  font-family: "normalidad-variable", sans-serif; 
  font-weight: 700;
  font-size: 16px;
  line-height: 120%;
  text-align: center;
  color: #312E2D;
  font-variation-settings: "wght" 700;
  background: #F7FF53;
  width: 120px;
  height: 44px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  :hover {
    color: #ffffff;
    background: #00854E;
    text-decoration: none;
  }
  :active {
    background: #4BE66A;
    color: #ffffff;
  }
`

export const socialIcon = css`
  margin-left: 14px;
  margin-right: 14px;
`
export const socialIconWhatsapp = css`
  margin-left: 7px;
`
export const actionsImgIconsSocial = css`
img{
  transition: filter 0.3s ease-out;
}
:hover {
  color: #F7FF53;
  img {
    filter: brightness(0) saturate(100%) invert(99%) sepia(63%) saturate(1577%) hue-rotate(16deg) brightness(116%) contrast(114%);
  }
}
:active {
  color: #4BE66A;
  img {
    filter: brightness(0) saturate(100%) invert(94%) sepia(27%) saturate(1948%) hue-rotate(56deg) brightness(105%) contrast(80%);
  }
}
`
export const headerMobile = css`
@media (max-width: 768px) {
  padding-top: 40px;
  padding-bottom: 40px;
    .logoMobile img {
      max-width: 300px;
      height: auto;
    }
}

@media (min-width: 992px){
  display: none;
}

.socialsContainersMobile{
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: flex-start;
    width: 100%;
    height: auto;
}

.socialitensMobile{
  margin-left: 0px;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: space-around;
  @media (max-width: 500px){
    margin-left: 0px;
  }
}
`
export const navigator = css`
position: relative;
padding: 0px;
& a {
  display: inline-block;
  color: #312E2D;
  line-height: 0.8;
  font-size: 25px;
  margin: 0;

  &:hover,
  .active {
    color: rebeccapurple;
  }

  &.search {
    margin-right: 16px;
  }
}
[class^="mei-"]:before, [class*=" mei-"]:before {
    margin-right: 0px;
    margin-left: 0px;
    margin-top: 2px;
}
`;

export const actionsImgIconsSocialMobile = css`
img{
  transition: filter 0.3s ease-out;
}
:hover {
  color: #F7FF53;
  img {
    filter: brightness(0) saturate(100%) invert(99%) sepia(63%) saturate(1577%) hue-rotate(16deg) brightness(116%) contrast(114%);
  }
}
:active {
  color: #4BE66A;
  img {
    filter: brightness(0) saturate(100%) invert(94%) sepia(27%) saturate(1948%) hue-rotate(56deg) brightness(105%) contrast(80%);
  }
}
`
